import { AppBar, Button, makeStyles, Toolbar } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles((theme) => ({
  appBar: {
    top: "auto",
    position: "fixed",
    bottom: 0,
    left: "auto",
    right: "auto",
    width: "650px",
  },
  grow: {
    flexGrow: 1,
  },
  button: {
    color: "inherit",

    "&:disabled": {
      color: "#999",
    },
  },
  buttonClearSelected: {
    minWidth: "210px",
    color: "inherit",
    "&:disabled": {
      color: "#999",
    },
  },
}));

type NotificationListBulkMenuProps = {
  areAllCheckboxesChecked: boolean;
  countNotificationSelected: number;
  toggleAllBulkModeClearNotification: (shouldClear: boolean) => void;
  removeAll: () => void;
  clearSelected: () => void;
};

export const NotificationListBulkMenu: React.FC<NotificationListBulkMenuProps> = ({
  areAllCheckboxesChecked,
  countNotificationSelected,
  toggleAllBulkModeClearNotification,
  removeAll,
  clearSelected,
}) => {
  const classes = useStyles();
  return (
    <AppBar
      className={classes.appBar}
      color="secondary"
      data-test="bulk-mode-bar"
    >
      <Toolbar>
        <Button
          color={areAllCheckboxesChecked ? "primary" : "inherit"}
          onClick={() =>
            toggleAllBulkModeClearNotification(!areAllCheckboxesChecked)
          }
          data-test="select-all"
        >
          Select All
        </Button>
        <div className={classes.grow} />
        <Button
          color="inherit"
          onClick={() => removeAll()}
          disabled={!countNotificationSelected}
          className={classes.button}
          data-test="bulk-cancel"
        >
          Cancel
        </Button>
        &nbsp;|&nbsp;
        <Button
          color="inherit"
          onClick={() => clearSelected()}
          disabled={!countNotificationSelected}
          className={classes.buttonClearSelected}
          data-test="bulk-clear"
        >
          Clear Selected{" "}
          {countNotificationSelected ? `(${countNotificationSelected})` : null}
        </Button>
      </Toolbar>
    </AppBar>
  );
};
